<script setup lang="ts">
import { BuildingSkyscraperIcon, ArrowRightIcon, UsersIcon } from 'vue-tabler-icons';

const emit = defineEmits(['select']);

const props = withDefaults(
  defineProps<{
    label?: string;
    labelE?: string;
    count?: string | number;
    memberCount?: string | number;
    village?: any;
  }>(),
  {
    label: 'ગામ',
    labelE: '',
    count: 0,
    memberCount: 0,
    village: null,
  }
);
</script>

<template>
  <v-card
    elevation="0"
    class="village-grid-card h-100 pa-3 pa-sm-4 d-flex flex-column justify-space-between position-relative overflow-hidden"
    style="cursor: pointer;"
    @click="emit('select', props.village)"
  >
    <div>
      <!-- Top Row: Icon & Family Count Pill -->
      <div class="d-flex align-center justify-space-between mb-2 mb-sm-3">
        <v-avatar size="40" class="village-avatar" color="primary">
          <BuildingSkyscraperIcon stroke-width="1.8" size="20" class="text-white" />
        </v-avatar>

        <v-chip size="x-small" variant="tonal" color="primary" class="font-weight-bold">
          {{ props.count }} કુટુંબ
        </v-chip>
      </div>

      <!-- Village Names -->
      <div class="village-title-group">
        <h3 class="text-subtitle-1 font-weight-black village-name">{{ props.label }}</h3>
        <div v-if="props.labelE || props.village?.villageNameE" class="text-caption text-medium-emphasis text-truncate">
          {{ props.labelE || props.village?.villageNameE }}
        </div>
      </div>
    </div>

    <!-- Bottom Action Bar -->
    <div class="d-flex align-center justify-space-between pt-2 pt-sm-3 mt-2 mt-sm-3 border-t border-opacity-25">
      <span class="text-caption font-weight-bold text-primary d-flex align-center">
        ગામ જુઓ
      </span>
      <v-avatar size="24" color="lightprimary" class="arrow-indicator">
        <ArrowRightIcon size="14" class="text-primary" />
      </v-avatar>
    </div>
  </v-card>
</template>

<style scoped>
.village-grid-card {
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(14px);
  border: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.02);
  transition: all 0.28s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.village-grid-card:hover {
  transform: translateY(-5px);
  border-color: rgba(var(--v-theme-primary), 0.4);
  box-shadow: 0 16px 36px rgba(30, 136, 229, 0.14), 0 4px 12px rgba(15, 23, 42, 0.04);
}

.village-avatar {
  background: linear-gradient(135deg, #1e88e5 0%, #1565c0 100%) !important;
  box-shadow: 0 6px 14px rgba(30, 136, 229, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.5);
  transition: transform 0.3s ease;
}

.village-grid-card:hover .village-avatar {
  transform: scale(1.08) rotate(6deg);
}

.village-name {
  color: #0f172a;
  line-height: 1.25;
}

.arrow-indicator {
  transition: transform 0.25s ease, background-color 0.25s ease;
}

.village-grid-card:hover .arrow-indicator {
  transform: translateX(4px);
  background-color: rgb(var(--v-theme-primary)) !important;
}

.village-grid-card:hover .arrow-indicator :deep(svg) {
  color: white !important;
}
</style>
